import { render, staticRenderFns } from "./FormSopimusHyvita.vue?vue&type=template&id=38b6fb03&scoped=true&"
import script from "./FormSopimusHyvita.vue?vue&type=script&lang=js&"
export * from "./FormSopimusHyvita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6fb03",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDatePicker,VForm,VMenu,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b6fb03')) {
      api.createRecord('38b6fb03', component.options)
    } else {
      api.reload('38b6fb03', component.options)
    }
    module.hot.accept("./FormSopimusHyvita.vue?vue&type=template&id=38b6fb03&scoped=true&", function () {
      api.rerender('38b6fb03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSopimusHyvita.vue"
export default component.exports